module.exports = __webpack_public_path__ + "static/media/lf-logo-new-w.878ce4fc.png";